<template>
  <!-- 服务请求 -->
  <div class="card">
    <b-card-header class="border-0">
      <h5 class="card-title mb-0">{{this.$t('menu.after-sales_service.service_request')}}</h5>
    </b-card-header>
    <b-card-body class="border-0 border-top">
      <div
        v-for="(info, index) in serviceInfo"
        :key="index"
        class="d-flex mb-3"
      >
        <label class="info-label">{{ info.label }}</label>
        <div class="flex-1">
          <!--     状态     -->
          <span v-if="index == 0" :class="[
              'badge',
              statusColor[info.value]
          ]">
            {{ getStatusTxt(SERVICE_STATUS_TXT,info.value) }}
          </span>
          <!--     请求类型     -->
          <editable-field
              v-if="index == 1"
              :value="info.value"
              type="multiselect"
              :editable="editable && hasPermissionFor('service.patch')"
              :select-options="WO_TYPE"
              value-type="int"
              :h5-wrap="false"
              @complete="editField($event,'type')"
          ></editable-field>
          <!--     创建时间     -->
          <span v-if="index == 2">{{ info.value }}</span>
          <!--     期望服务时间     -->
          <editable-field
              v-if="index == 3"
              :value="info.value"
              type="datetime"
              :editable="editable && hasPermissionFor('service.patch')"
              :h5-wrap="false"
              @complete="editField($event,'expectation_at')"
          ></editable-field>
          <!-- 紧急程度 -->
          <editable-field
              v-if="index == 4"
              :value="info.value"
              type="priority"
              :editable="editable && hasPermissionFor('service.patch')"
              value-type="int"
              :h5-wrap="false"
              @complete="editField($event,'priority')"
          ></editable-field>
        </div>
      </div>
      <div v-if="detailInfo.status == SERVICE_STATUS_CLOSED && detailInfo.cancel_reason" class="d-flex mb-3">
        <label class="info-label">{{this.$t('page.repair-request.CancelReason')}}</label>
        <div class="flex-1">{{ detailInfo.cancel_reason }}</div>
      </div>
      <div v-if="detailInfo.resolve_record" class="d-flex mb-3">
        <label class="info-label">{{this.$t('page.repair-request.SettlementRecord')}}</label>
        <div class="flex-1">{{ detailInfo.resolve_record }}</div>
      </div>
      <div class="border-top">
        <div class="d-flex justify-content-end mt-2">
          <button
            v-if="![SERVICE_STATUS_CLOSED, SERVICE_STATUS_PROCESSED].includes(parseInt(detailInfo.status))"
            type="button"
            class="btn btn-outline-danger waves-effect waves-light me-3"
            v-perm="'service.patch'"
            @click="closeService"
          >
            {{ this.$t('page.repair-request.CancelRequest') }}
          </button>
          <button
            v-if="![SERVICE_STATUS_CLOSED, SERVICE_STATUS_PROCESSED].includes(parseInt(detailInfo.status))"
            type="button"
            class="btn btn-info waves-effect waves-light me-3"
            v-perm="'service.patch'"
            @click="resolveHandler"
          >
            {{this.$t('page.repair-request.DirectSolution')}}
          </button>
          <button
            v-if="![SERVICE_STATUS_CLOSED, SERVICE_STATUS_PROCESSED].includes(parseInt(detailInfo.status))&&detailInfo.type!=5"
            type="button"
            class="btn btn-primary waves-effect waves-light"
            @click="handlerJump"
            v-perm="'order.post'"
          >
            {{this.$t('page.repair-request.CreateWorkOrder')}}
          </button>
        </div>
      </div>
    </b-card-body>
  </div>
  <!-- 联系人 -->
  <div class="card">
    <b-card-header class="border-0">
      <h5 class="card-title mb-0">{{this.$t('page.work-order.contact')}}</h5>
    </b-card-header>
    <b-card-body class="border-0 border-top">
      <div class="d-flex mb-3">
        <div class="user-img me-3">
          <img :src="userInfo.img" alt="" />
        </div>
        <div class="user-base d-flex flex-column justify-content-between">
          <div class="user-name fw-bold">{{ userInfo.name }}</div>
          <div class="user-role text-muted">{{ userInfo.role }}</div>
        </div>
      </div>
      <div class="user-phone mb-1 d-flex align-items-center">
        <i class="ri-phone-line me-3 fs-4 text-muted"></i>
        <span>{{ userInfo.phone }}</span>
      </div>
      <div class="user-email d-flex align-items-center" v-if="false">
        <i class="ri-mail-line me-3 fs-4 text-muted"></i>
        <span> {{ userInfo.email }}</span>
      </div>
    </b-card-body>
  </div>
  <!-- 公司信息 -->
  <div class="card flex-1 overflow-auto">
    <b-card-body>
      <div class="company-base d-flex flex-column align-items-center mb-3">
        <div class="company-icon mb-2">
          <show-avatar :img-src="companyInfo.logo" :title="companyInfo.name" size="md"></show-avatar>
        </div>
        <div class="company-name fw-bold">{{ companyInfo.name }}</div>
      </div>
      <div class="company-detail">
        <div class="d-flex mb-3">
          <label class="info-label">{{this.$t('page.industry')}}</label>
          <div class="flex-1">{{ $t(`['${companyInfo.industry}']`) }}</div>
        </div>
        <div class="d-flex mb-3">
          <label class="info-label">{{this.$t('page.contact_number')}}</label>
          <div class="flex-1">{{ companyInfo.tel }}</div>
        </div>
        <div class="d-flex mb-3">
          <label class="info-label">{{this.$t('page.email')}}</label>
          <div class="flex-1">{{ companyInfo.email }}</div>
        </div>
        <div class="d-flex mb-3">
          <label class="info-label">{{this.$t('page.homepage')}}</label>
          <div class="flex-1">{{ companyInfo.home_url }}</div>
        </div>
        <div class="d-flex">
          <label class="info-label">{{this.$t('page.company_address')}}</label>
          <div class="flex-1">{{ addressText(companyInfo) }}</div>
        </div>
      </div>
    </b-card-body>
  </div>
  <b-modal
    v-model="showModal"
    hide-footer
    :title="this.$t('page.repair-request.SettlementRecord')"
    scrollable
    centered
    size="lg"
  >
    <div class="modal-body border-top" style="max-height: 60vh;">
      <div class="mb-3">
        <label class="form-label field-title" for="meta-keywords-input">{{this.$t('page.repair-request.RecordDescription')}}</label>
        <input type="text" class="form-control" :class="v$.resolveForm.resolve_record.$errors.length ? 'is-invalid' : ''" :placeholder="this.$t('page.repair-request.RecordDescription')" v-model="resolveForm.resolve_record"/>
      </div>
    </div>
    <div class="modal-footer v-modal-footer" style="padding-right: 20px;padding-bottom: 20px;">
      <b-button type="button" variant="light" @click="showModal = false">{{this.$t('base.cancel')}}
      </b-button>
      <b-button type="button" variant="primary" @click="resolveSubmit">{{this.$t('base.done')}}</b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  priorityColor,
  statusColor,
  filterPriority,
  serviceInfo,
} from "../data.js";
import moment from "moment";
import _ from "lodash";
import {customerDetail, patchRepairService} from "@/service/index";
import { SERVICE_STATUS_CLOSED, SERVICE_STATUS_PROCESSED, SERVICE_STATUS_TXT, WO_TYPE, SERVICE_STATUS_TO_BE_CLASSIFIED, SERVICE_STATUS_PENDING } from "@/config/common";
import { getStatusTxt } from "@/helpers/common";
import EditableField from "@/views/work-order/components/widgets/editable-field";
import {alertComfirmWithTextarea} from "@/helpers/swal";
import showAvatar from "@/views/widgets/show-avatar";
import {addressText} from "@/helpers/common";
import {required} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },
  },
  emits: ["initDetailInfo"],
  data() {
    return {
      SERVICE_STATUS_TO_BE_CLASSIFIED,
      SERVICE_STATUS_PENDING,
      SERVICE_STATUS_CLOSED,
      SERVICE_STATUS_PROCESSED,
      SERVICE_STATUS_TXT,
      WO_TYPE,
      priorityColor,
      statusColor,
      serviceInfo,
      userInfo: {
        img: require("@/assets/images/default-user.png"),
        name: "-",
        role: "-",
        phone: "-",
        email: "-",
      },
      companyInfo: {
        // logo: require("@/assets/company-icon.svg"),
      },
      editable: false,
      showModal: false,
      resolveForm: {
        resolve_record: "",
      }
    };
  },
  validations: {
    resolveForm: {
      resolve_record: { required },
    }
  },
  watch: {
    detailInfo: {
      immediate: true,
      handler(val) {
        console.log('right:',this.detailInfo)
        if (val) {
          this.filterServiceInfo();
          this.filterUserInfo();
          this.getCustomerInfo(val.customer);
          if (![SERVICE_STATUS_PROCESSED, SERVICE_STATUS_CLOSED].includes(parseInt(this.detailInfo.status))) {
            this.editable = true
          } else {
            this.editable = false
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    moment,
    getStatusTxt,
    filterPriority,
    addressText,
    filterServiceInfo() {
      this.serviceInfo[0].value = this.detailInfo.status;
      this.serviceInfo[1].value = this.detailInfo.type;
      this.serviceInfo[2].value = moment(this.detailInfo.created_at).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.serviceInfo[3].value = moment(this.detailInfo.expectation_at).format(
        "YYYY-MM-DD"
      );
      this.serviceInfo[4].value = this.detailInfo.priority;
    },
    filterUserInfo() {
      this.userInfo.name = this.detailInfo.customer_contact_name;
      this.userInfo.phone = this.detailInfo.customer_contact_number;
    },
    getCustomerInfo(id) {
      customerDetail(id).then((res) => {
        if (res && res.payload) {
          let detail = res.payload;
          this.companyInfo = _.merge(this.companyInfo, detail);
          this.userInfo.email = this.companyInfo.email
          this.userInfo.role = this.companyInfo.name
        }
      });
    },
    closeService() {
      alertComfirmWithTextarea(`${this.$t('page.repair-request.CancelRequest')}?`, '', this.$t('page.repair-request.PleaseEnterReasonForCancellation')).then(reason => {
        let params = {
          id: this.detailInfo.id,
          status: SERVICE_STATUS_CLOSED,
          cancel_reason: reason
        };
        this.edit(params)
      })
    },
    handlerJump() {
      localStorage.setItem('serviceData', JSON.stringify(this.detailInfo))
      this.$router.push({
        path: "/work-order-add/" + this.detailInfo.type,
        query: {
          // id: data.id,
        },
      });
    },
    editField(e,fieldName) {
      console.log(fieldName, `${this.$t('page.repair-request.TheFieldUpdatedTo')}：`, e)
      const form = {
        id: this.detailInfo.id,
      }
      form[fieldName] = e
      if (fieldName === 'type' && e && this.detailInfo.status == SERVICE_STATUS_TO_BE_CLASSIFIED) {
        form['status'] = SERVICE_STATUS_PENDING
      }
      this.edit(form)
    },
    edit(params) {
      patchRepairService(params.id, params).then((res) => {
        if (res && res.payload) {
          this.$emit("initDetailInfo");
        }
      });
    },
    resolveHandler() {
      this.showModal = true
    },
    async resolveSubmit() {
      this.v$.resolveForm.$touch()
      const result = await this.v$.$validate()
      if (!result) {
        return
      }

      let params =  {
        id: this.detailInfo.id,
        resolve_record: this.resolveForm.resolve_record,
        status: SERVICE_STATUS_PROCESSED
      }

      patchRepairService(params.id, params).then((res) => {
        if (res && res.payload) {
          this.$emit("initDetailInfo");
        }
      });
      this.showModal = false
    },
  },
  components: {
    EditableField,
    showAvatar,
  },
};
</script>

<style scoped lang="scss">
.info-label {
  width: 30%;
  margin-right: 20px;
  margin-bottom: 0;
}
.user-img {
  width: 50px;
  height: 50px;
}
.company-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
</style>
